module.exports = __webpack_public_path__ + "img/DE02091.c3a3d805.png";